exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll[data-v-59521834] {\n  max-height: 400px;\n  overflow: auto;\n}\n.scroll[data-v-59521834]::-webkit-scrollbar {\n  background-color: transparent;\n  width: 8px;\n}\n.scroll[data-v-59521834]::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: #5a5a5a;\n}\n", ""]);

// exports
